export default function reset(initialState) {

  return function(state) {
    const data = initialState()
    for (let key of Object.keys(data)) {
      state[key] = data[key]
    }
  }
}
